/**
 * StreamSaver bootstrap.
 *
 * Self-hosted bridge under /streamsaver/* (vendored from streamsaver@2.0.6).
 * If the package is bumped, re-copy mitm.html + sw.js from
 * node_modules/streamsaver/ into apps/agent-studio/public/streamsaver/ and
 * update the version pin in this comment.
 *
 * Pinned 3rd-party assets (must be re-copied on upgrade):
 * - apps/agent-studio/public/streamsaver/mitm.html
 * - apps/agent-studio/public/streamsaver/mitm.js
 *   (extracted from the upstream <script> in mitm.html so it loads
 *   under script-src 'self'; the deployed CSP rejects inline scripts)
 * - apps/agent-studio/public/streamsaver/sw.js
 */
import streamSaver from 'streamsaver';

/** Same-origin path served verbatim by Vite from apps/agent-studio/public/. */
const SELF_HOSTED_MITM_PATH = '/streamsaver/mitm.html';

/**
 * Configures StreamSaver to use the self-hosted mitm bridge instead of
 * jimmywarting.github.io. Safe to call before render; SW touch points are
 * guarded by feature detection so SSR / older browsers short-circuit cleanly.
 */
export function configureStreamSaver(): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  streamSaver.mitm = SELF_HOSTED_MITM_PATH;
}
